import React, { useState } from 'react';
import { Icon } from '@iconify/react';
import { Link } from 'react-scroll';
function Header() {
	const [showDropdownMenu, setShowDropdownMenu] = useState(false);
	return (
		<header className="px-4 pt-10 bg-primary" id="home">
			<div className="hidden md:flex flex-row justify-center">
				<nav>
					<ul className="flex gap-x-8 text-slate-300 [&>*]:font-medium [&>*]:text-sm">
						<Link
							to="hero"
							activeClass="active"
							spy={true}
							smooth={true}
							offset={-50}
							duration={500}
						>
							<li className="text-normal flex flex-col cursor-pointer hover:text-slate-100 font-medium">
								Home
							</li>
						</Link>

						<Link
							to="skills"
							activeClass="active"
							spy={true}
							smooth={true}
							offset={-70}
							duration={500}
						>
							<li className="text-normal flex flex-col cursor-pointer hover:text-slate-100 font-medium">
								Skills
							</li>
						</Link>
						<Link
							to="projects"
							activeClass="active"
							spy={true}
							smooth={true}
							offset={-70}
							duration={500}
						>
							<li className="text-normal flex flex-col cursor-pointer hover:text-slate-100 font-medium">
								Projects
							</li>
						</Link>
						<Link
							to="experiences"
							activeClass="active"
							spy={true}
							smooth={true}
							offset={-70}
							duration={500}
						>
							<li className="text-normal flex flex-col cursor-pointer hover:text-slate-100 font-medium">
								Work experience
							</li>
						</Link>
						<Link
							to="contacts"
							activeClass="active"
							spy={true}
							smooth={true}
							offset={-70}
							duration={500}
						>
							<li className="text-normal flex flex-col cursor-pointer hover:text-slate-100 font-medium">
								Get in touch
							</li>
						</Link>
					</ul>
				</nav>
			</div>
			<div className="md:hidden relative">
				<button onClick={() => setShowDropdownMenu((state) => !state)}>
					<Icon
						icon="material-symbols:menu"
						className="text-2xl text-slate-100"
					/>
				</button>
				{showDropdownMenu && (
					<div className="bg-white px-8 py-5 rounded-sm absolute top-0 z-50 min-w-[200px]">
						<nav className="py-4">
							<ul className="flex flex-col gap-4">
								<Link
									to={'hero'}
									activeClass="active"
									spy={true}
									smooth={true}
									offset={-70}
									duration={500}
									className="active:font-semibold"
									onClick={() => setShowDropdownMenu(false)}
								>
									<li>Home</li>
								</Link>
								<Link
									to={'skills'}
									activeClass="active"
									spy={true}
									smooth={true}
									offset={-70}
									duration={500}
									onClick={() => setShowDropdownMenu(false)}
								>
									<li>Skills</li>
								</Link>
								<Link
									to={'projects'}
									activeClass="active"
									spy={true}
									smooth={true}
									offset={-70}
									duration={500}
									onClick={() => setShowDropdownMenu(false)}
								>
									<li>Projects</li>
								</Link>
								<Link
									to={'experiences'}
									activeClass="active"
									spy={true}
									smooth={true}
									offset={-70}
									duration={500}
									onClick={() => setShowDropdownMenu(false)}
								>
									<li>Experience</li>
								</Link>
								<Link
									to={'contacts'}
									activeClass="active"
									spy={true}
									smooth={true}
									offset={-70}
									duration={500}
									onClick={() => setShowDropdownMenu(false)}
								>
									<li>Get in touch</li>
								</Link>
							</ul>
						</nav>
					</div>
				)}
			</div>
		</header>
	);
}

export default Header;
